export const customStyles = {
  "--base-font-size": "16px",
  "--base-maxwidth": "",

  "--reviewsio-logo-style": "var(--logo-normal)",

  "--common-star-color": "#035E61",
  "--common-star-disabled-color": " rgba(0,0,0,0.25)",
  "--medium-star-size": " 22px",
  "--small-star-size": "19px",
  "--x-small-star-size": "16px",
  "--x-small-star-display": "inline-flex",

  "--header-order": "1",
  "--header-width": "160px",
  "--header-bg-start-color": "transparent",
  "--header-bg-end-color": "transparent",
  "--header-gradient-direction": "135deg",
  "--header-padding": "0.5em",
  "--header-border-width": "0px",
  "--header-border-color": "rgba(0,0,0,0.1)",
  "--header-border-radius": "0px",
  "--header-shadow-size": "0px",
  "--header-shadow-color": "rgba(0, 0, 0, 0.1)",

  "--header-star-color": "#035E61",
  "--header-disabled-star-color": "#035E61",
  "--header-heading-text-color": "inherit",
  "--header-heading-font-size": "inherit",
  "--header-heading-font-weight": "inherit",
  "--header-heading-line-height": "inherit",
  "--header-heading-text-transform": "inherit",
  "--header-subheading-text-color": "#035E61",
  "--header-subheading-font-size": "inherit",
  "--header-subheading-font-weight": "inherit",
  "--header-subheading-line-height": "inherit",
  "--header-subheading-text-transform": "inherit",

  "--item-maximum-columns": "5",
  "--item-background-start-color": "#f7f7f4",
  "--item-background-end-color": "#f7f7f4",
  "--item-gradient-direction": "135deg",
  "--item-padding": "0.5em",
  "--item-border-width": "0px",
  "--item-border-color": "rgba(0,0,0,0.1)",
  "--item-border-radius": "0px",
  "--item-shadow-size": "0px",
  "--item-shadow-color": "rgba(0,0,0,0.1)",

  "--heading-text-color": "#035E61",
  "--heading-text-font-weight": " 600",
  "--heading-text-font-family": "open sans",
  "--heading-text-line-height": " 1.4",
  "--heading-text-letter-spacing": "0",
  "--heading-text-transform": "none",

  "--body-text-color": "#035E61",
  "--body-text-font-weight": "400",
  "--body-text-font-family": "open sans",
  "--body-text-line-height": " 1.4",
  "--body-text-letter-spacing": "0",
  "--body-text-transform": "none",

  "--scroll-button-icon-color": "#035E61",
  "--scroll-button-icon-size": "16px",
  "--scroll-button-bg-color": "#F7F7F4",

  "--scroll-button-border-width": "2px",
  "--scroll-button-border-color": "#035E61",

  "--scroll-button-border-radius": "60px",
  "--scroll-button-shadow-size": "0px",
  "--scroll-button-shadow-color": "rgba(0,0,0,0.1)",
  "--scroll-button-horizontal-position": "0px",
  "--scroll-button-vertical-position": "0px",

  "--badge-icon-color": "#0E1311",
  "--badge-icon-font-size": "15px",
  "--badge-text-color": "#0E1311",
  "--badge-text-font-size": "inherit",
  "--badge-text-letter-spacing": "inherit",
  "--badge-text-transform": "inherit",

  "--author-font-size": "inherit",
  "--author-font-weight": "inherit",
  "--author-text-transform": "inherit",

  "--photo-video-thumbnail-size": "60px",
  "--photo-video-thumbnail-border-radius": "0px",

  "--popup-backdrop-color": "#ffffff",
  "--popup-color": "#ffffff",
  "--popup-star-color": "inherit",
  "--popup-disabled-star-color": "inherit",
  "--popup-heading-text-color": "#035E61",
  "--popup-body-text-color": "#035E61",
  "--popup-badge-icon-color": "#035E61",
  "--popup-badge-icon-font-size": "19px",
  "--popup-badge-text-color": "#035E61",
  "--popup-badge-text-font-size": "14px",
  "--popup-border-width": "0px",
  "--popup-border-color": "rgba(0,0,0,0.1)",
  "--popup-border-radius": "0px",
  "--popup-shadow-size": "0px",
  "--popup-shadow-color": "rgba(0,0,0,0.1)",
  "--popup-icon-color": "#0E1311",

  "--tooltip-bg-color": "#0E1311",
  "--tooltip-text-color": "#ffffff",
};

export default customStyles;
